import { IState } from '../../store';

export const selectVillageId = (state: IState): number => {
  return state.villageData.village.id;
};
